import { render, staticRenderFns } from "./ViewFields.vue?vue&type=template&id=2bdfa797&scoped=true"
import script from "./ViewFields.vue?vue&type=script&lang=js"
export * from "./ViewFields.vue?vue&type=script&lang=js"
import style0 from "./ViewFields.vue?vue&type=style&index=0&id=2bdfa797&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdfa797",
  null
  
)

export default component.exports